(function () {
  var trigger = document.querySelector('[data-mobile-menu-trigger]');
  var menu = document.querySelector('[data-mobile-menu]');
  if (!trigger || !menu) return;

  var header = trigger.closest('header');
  var panel = menu.querySelector('[data-mobile-menu-panel]');
  var backdrop = menu.querySelector('[data-mobile-menu-backdrop]');
  var openLabel = trigger.dataset.openLabel || '';
  var closeLabel = trigger.dataset.closeLabel || '';
  var isOpen = false;
  var hasMeasured = false;

  menu.setAttribute('inert', '');

  function measureTrigger() {
    var rect = trigger.getBoundingClientRect();
    // Suppress the morph transition for closed-state measures (first + scroll/resize), so
    // the collapsed panel snaps to the trigger instantly instead of animating toward it.
    // Only the open/close morph itself should animate.
    var suppress = (!hasMeasured || !isOpen) && panel;
    if (suppress) panel.style.transition = 'none';
    menu.style.setProperty('--menu-origin-top', rect.top + 'px');
    menu.style.setProperty('--menu-origin-left', rect.left + 'px');
    menu.style.setProperty('--menu-origin-width', rect.width + 'px');
    menu.style.setProperty('--menu-origin-height', rect.height + 'px');
    if (suppress) {
      panel.offsetHeight; // eslint-disable-line no-unused-expressions
      panel.style.transition = '';
    }
    hasMeasured = true;
  }

  // Compensate for the removed scrollbar so the fixed header doesn't shift on open.
  function lockScroll() {
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = scrollbarWidth + 'px';
    }
    document.body.style.overflow = 'hidden';
  }

  function unlockScroll() {
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }

  function open() {
    // Drop the Headroom transform first so the trigger is measured in its final,
    // untransformed position; otherwise the panel grows from the pre-snap spot.
    if (header) header.setAttribute('data-menu-open', 'true');
    measureTrigger();
    isOpen = true;
    menu.setAttribute('aria-hidden', 'false');
    menu.setAttribute('data-state', 'open');
    menu.removeAttribute('inert');
    menu.style.pointerEvents = 'auto';
    trigger.setAttribute('aria-expanded', 'true');
    trigger.setAttribute('aria-label', closeLabel);
    lockScroll();
  }

  function close(returnFocus) {
    isOpen = false;
    menu.setAttribute('aria-hidden', 'true');
    menu.setAttribute('data-state', 'closed');
    menu.setAttribute('inert', '');
    menu.style.pointerEvents = 'none';
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-label', openLabel);
    if (header) header.setAttribute('data-menu-open', 'false');
    unlockScroll();
    if (returnFocus) trigger.focus();
  }

  trigger.addEventListener('click', function () {
    if (isOpen) close(true); else open();
  });

  if (backdrop) {
    backdrop.addEventListener('click', function () { close(true); });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) close(true);
  });

  measureTrigger();
  // Re-measure after font swap — the trigger's width changes once Manrope loads.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(measureTrigger);
  }
  window.addEventListener('load', measureTrigger);
  window.addEventListener('resize', measureTrigger);

  // Keep the closed panel glued to the trigger as the header collapses on scroll.
  var scrollScheduled = false;
  window.addEventListener('scroll', function () {
    if (isOpen || scrollScheduled) return;
    scrollScheduled = true;
    requestAnimationFrame(function () {
      scrollScheduled = false;
      if (!isOpen) measureTrigger();
    });
  }, { passive: true });
})();
